module.exports = __webpack_public_path__ + "img/datxe_ctv_offline.934990a9.png";